import {AppBar, Box, Toolbar, Stack, Drawer, Grid} from '@mui/material';
import {useMediaQuery} from '@mui/material';
import {useContext} from 'react';
import AuthContext from '../../context/AuthContext';
import SideBarMenu from '../../components/sideBar/sideBarMenu';
import {TriggerButton} from '../../components/sideBar/sideBarMenu';

/**
 * Component representing the header section.
 *
 * @component
 * @returns {JSX.Element} The Header component.
 */
const Header = () => {
  const {isMenuOpen, handleDrawerClose} = useContext(AuthContext);
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  return (
    <Box>
      {!isSmallScreen && (
        <Box
          sx={{
            backgroundColor: 'white',
            position: 'sticky',
            zIndex: 300,
            top: 0,
            boxSizing: 'border-box',
            boxShadow: '0px 14px 65px -40px rgba(0,0,0,0.69)',
          }}
        >
          <AppBar position="static" sx={{backgroundColor: 'white', pt: 1}} elevation={0}>
            <Toolbar sx={{justifyContent: 'end'}}>
              <TriggerButton
                iconButtonStyles={{
                  mr: 6,
                }}
              />
            </Toolbar>
          </AppBar>
        </Box>
      )}
      <Drawer anchor="right" open={isMenuOpen} onClose={handleDrawerClose}>
        <SideBarMenu />
      </Drawer>

      {isSmallScreen && (
        <Grid container alignItems="center" justifyContent="flex-end" p={3} columnGap={1}>
          <Grid item xs={2}>
            <Toolbar sx={{p: 0, justifyContent: 'flex-end'}}>
              <TriggerButton
                iconButtonStyles={{
                  mr: 1,
                }}
              />
            </Toolbar>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

/**
 * Component representing the general information base layout (this is for pages that won't have a progress bar).
 *
 * @component
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The content to be displayed in the layout.
 * @returns {JSX.Element} The GeneralInfoBase component.
 */
export const GeneralInfoBase = ({children}) => (
  <Stack minHeight="100vh" justifyContent="space-between">
    <Box>
      <Header />
      <Stack
        flexGrow={1}
        alignItems="center"
        justifyContent="flex-start"
        sx={{
          marginX: {
            xs: 3,
            sm: 5,
            md: 10,
            lg: 10,
          },
          marginTop: {
            xs: 0,
            sm: 1,
            md: 2,
          },
          boxSizing: 'border-box',
        }}
      >
        {children}
      </Stack>
    </Box>
  </Stack>
);
